import { useEffect, useRef, useState } from 'react';

export const useInvokeCallback = (callback?: () => void) => {
  const [callCount, setCallCount] = useState(0);
  const shouldInvoke = useRef(false);

  useEffect(() => {
    if (callCount > 0 && shouldInvoke.current) {
      shouldInvoke.current = false;
      callback?.();
    }
  }, [callCount, callback]);

  const invokeCallback = () => {
    setCallCount((count) => count + 1);
    shouldInvoke.current = true;
  };

  return invokeCallback;
};
